//export var dns: string = "http://79.137.75.178/ws_rimtrack_all/";
//export var dns: string = "http://localhost:8080/rimtrack-all-v2/";
//export var dns: string = "http://dev.rimtrack.com/ws_rimtrack_all/";
//export var dns : string="http://192.168.1.108:8080/"
//export var dns: string = "http://79.137.75.178:8080/ws_rimtrack_all/";

/*
export var dns: string = "http://traci.tn/ws_rimtrack_all/";
export var imagesDir: string = "http://traci.tn/images/";
export var imagescar:string="http://traci.tn/images/cars/";
export var nominatim_dns:string = "http://traci.tn/nominatim";
export var time_difference:number = -3600000;
export var imagesPOIDir: string = "http://traci.tn/images/poi/";
*/

// export var version: string = 'finek';
//export var version: string = 'fleet';
export var version: string = 'traci';
import { Injectable } from '@angular/core';
import { Events } from 'ionic-angular';

//54.37.88.163
@Injectable()
export class GlobalService {
	dns: string;
	imagescar: string;
	nominatim_dns: string;
	imagesPOIDir: string;
	imagesDir: string;
	time_difference: number;
	servername: string = '213.150.181.221:8080';

	constructor(public events: Events) {
		this.dns = 'http://' + this.servername + '/ws_rimtrack_all/';
		this.imagesDir = 'http://' + this.servername + '/images/';
		this.imagescar = 'http://' + this.servername + '/images/cars/';
		this.nominatim_dns = 'http://' + this.servername + '/nominatim';
		this.time_difference = -3600000;
		this.imagesPOIDir = 'http://' + this.servername + '/images/poi/';
		//this.servername =servername;
	}

	getservername() {
		return this.servername;
	}
	setservername(servername: string) {
		this.servername = servername;
		this.dns = 'http://' + servername + '/ws_rimtrack_all/';

		this.imagesDir = 'http://' + servername + '/images/';
		this.imagescar = 'http://' + servername + '/images/cars/';
		this.nominatim_dns = 'http://' + servername + '/nominatim';
		this.time_difference = -3600000;
		this.imagesPOIDir = 'http://' + servername + '/images/poi/';
		this.events.publish('dns', this.dns);
		this.events.publish('imagesDir', this.imagesDir);
		this.events.publish('imagescar', this.imagescar);
		this.events.publish('nominatim_dns', this.nominatim_dns);
		this.events.publish('time_difference', this.time_difference);
		this.events.publish('imagesPOIDir', this.imagesPOIDir);
	}
	getDns() {
		return this.dns;
	}
	getnominatim_dns() {
		return this.nominatim_dns;
	}
	getimagesPOIDir() {
		return this.imagesPOIDir;
	}
	getimagesDir() {
		return this.imagesDir;
	}
	gettime_difference() {
		return this.time_difference;
	}
	getimagescar() {
		return this.imagescar;
	}

	//export var serverName:string ="traci.tn";
	/*export var dns: string = "http://"+serverName+"/ws_rimtrack_all/";
  export var imagesDir: string = "http://"+serverName+"/images/";
  export var imagescar:string="http://"+serverName+"/images/cars/";
  export var nominatim_dns:string = "http://"+serverName+"/nominatim";
  export var time_difference:number = -3600000;
  export var imagesPOIDir: string = "http://"+serverName+"/images/poi/";
  */

	/*export var dns: string = "http://54.37.88.163/ws_rimtrack_all/";
  export var imagescar:string="http://54.37.88.163/images/cars/";
  export var nominatim_dns:string = "http://54.37.88.163/nominatim";
  export var imagesPOIDir: string = "http://54.37.88.163/images/poi/";
  export var imagesDir: string = "http://54.37.88.163/images/";
  export var time_difference:number = -3600000;
  */
}



// WEBPACK FOOTER //
// ./src/providers/global.config.ts